module.exports = __webpack_public_path__ + "static/media/chat_green.c7df3185.svg";